import React from "react";
import "./Results.css";
import Phonetics from "./Phonetics";
import Meaning from "./Meaning";

export default function Results(props) {
  if (props.results) {
    return (
    <div className="Results">
      <section>
        <h3>
          {props.results.word}
        </h3>
        <div>{props.results.phonetics.map(function(phonetics, index) {
          return (
            <div key={index}>
              <Phonetics phonetics={phonetics} />
            </div>
          );
          })}
        </div>
      </section>
      {props.results.meanings.map(function(meaning, index) {
        return (
          <section key={index}>
            <Meaning meaning={meaning} />
          </section>
        );
      })}
    </div>
  );} else {
    return null;
  }
}